/*
 * 商品画像ギャラリー
 *
 * - バリエーション（normal / slim）を切り替えると画像セットも切り替える
 * - 各セット内はドットで送る（旧テーマの slick 相当）
 *
 * バリエーションの検知は、Dawn がフォーム内に持っている
 * input[name="id"]（選択中バリエーションID）の変化を見る方式。
 * Dawn の内部イベント名に依存しないため、Dawn の更新に強い。
 */
(function () {
  'use strict';

  function initGallery(gallery) {
    if (gallery.dataset.iroiroReady === 'true') return;
    gallery.dataset.iroiroReady = 'true';

    var sets = Array.prototype.slice.call(
      gallery.querySelectorAll('.iroiro-gallery__set')
    );
    if (sets.length === 0) return;

    function showSet(variantId) {
      var matched = false;
      sets.forEach(function (set) {
        var isCurrent = set.dataset.variantId === String(variantId);
        set.classList.toggle('is-current', isCurrent);
        if (isCurrent) matched = true;
      });
      // 該当がなければ最初のセットを出しておく（画像が消えるのを防ぐ）
      if (!matched) sets[0].classList.add('is-current');
    }

    function showSlide(set, index) {
      var slides = set.querySelectorAll('.iroiro-gallery__slide');
      var dots = set.querySelectorAll('.iroiro-gallery__dot');
      if (slides.length === 0) return;
      var next = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-current', i === next);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-current', i === next);
      });
    }

    function currentIndex(set) {
      var slides = Array.prototype.slice.call(
        set.querySelectorAll('.iroiro-gallery__slide')
      );
      var found = slides.findIndex(function (s) {
        return s.classList.contains('is-current');
      });
      return found < 0 ? 0 : found;
    }

    gallery.addEventListener('click', function (event) {
      var dot = event.target.closest('.iroiro-gallery__dot');
      if (dot) {
        return showSlide(
          dot.closest('.iroiro-gallery__set'),
          parseInt(dot.dataset.index, 10)
        );
      }

      var arrow = event.target.closest('.iroiro-gallery__arrow');
      if (!arrow) return;
      var set = arrow.closest('.iroiro-gallery__set');
      var step = arrow.classList.contains('iroiro-gallery__arrow--prev') ? -1 : 1;
      showSlide(set, currentIndex(set) + step);
    });

    // ── バリエーションの変化を監視 ──
    var section = gallery.closest('.shopify-section') || document;
    var input = section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (!input) return;

    showSet(input.value);

    // Dawn は JS で input.value を書き換えるため、値の変化を直接監視する
    var lastValue = input.value;
    var check = function () {
      if (input.value === lastValue) return;
      lastValue = input.value;
      showSet(input.value);
    };

    // 入力欄の change と、Dawn の再描画（属性変更）の両方を拾う
    input.addEventListener('change', check);
    new MutationObserver(check).observe(input, {
      attributes: true,
      attributeFilter: ['value'],
    });
    // Dawn が value プロパティだけ書き換える場合に備えて操作後にも確認する
    section.addEventListener('change', function () {
      window.setTimeout(check, 0);
    });
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-iroiro-gallery]')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
